<div class="disclaimer-block">
  <ng-container  *ngFor="let banner of data">
    <ng-container *ngIf="banner.show">
      <app-disclaimer-banner  [data]="banner"></app-disclaimer-banner>
    </ng-container>
  </ng-container>
</div>
